<template>
	<div class="c-generations-list">
		<div class="c-generations-list__loader" v-if="processing">
			<div class="c-spinner"></div>
		</div>
		<Item v-for="gen in generations" :key="gen.id" :generation="gen">
		</Item>
		<div class="c-generations-list__empty-state" v-if="empty">
			<strong> Nothing to show here. </strong>
			<p>Your saved AI generations will show up here.</p>
		</div>
		<button
			:class="['btn btn-box', { 'btn-primary': processing === true }]"
			@click="loadMore"
			v-if="!max && !processing && !empty"
		>
			<span class="c-spinner" v-if="processing"></span>
			<span> Load more </span>
		</button>
	</div>
</template>

<script>
import Item from './item.vue';

export default {
	components: {
		Item,
	},

	data: function () {
		return {
			params: {
				skip: 0,
			},

			processing: false,

			max: false,
		};
	},

	computed: {
		empty: function () {
			if (this.processing) {
				return false;
			}
			return this.generations.length === 0;
		},
		generations: function () {
			return this.$store.getters['generations/all'];
		},
	},

	methods: {
		async load() {
			this.processing = true;

			const generations = await this.$store.dispatch(
				'generations/refresh',
				this.params
			);

			if (generations.length < 50) {
				this.max = true;
			}

			this.processing = false;
		},
		async loadMore() {
			this.processing = true;

			this.params.skip += 1;

			const generations = await this.$store.dispatch(
				'generations/loadMore',
				this.params
			);

			if (generations.length < 50) {
				this.max = true;
			}

			this.processing = false;
		},
	},

	mounted: function () {
		this.load();
	},
};
</script>

<style lang="scss">
.c-generations-list {
	max-width: 680px;
	margin: 0 auto;
	padding-top: 2rem;
	padding-bottom: 2rem;

	&__empty-state {
		text-align: center;

		strong {
			display: block;
			font-weight: 500;
			margin-bottom: 0.5rem;
		}
	}

	> .btn {
		width: 100%;
	}

	&__loader {
		display: flex;
		justify-content: center;
		margin-bottom: 1rem;

		> .c-spinner {
			border-color: var(--color-primary);
			border-bottom-color: transparent;
		}
	}
}
</style>
